import React from "react";
import theme from "app/Theme/Theme";
import Svg, { ClipPath, Defs, G, Path } from "react-native-svg";
import normalize from "app/utils/normalize";

const CameraVideoIcon = ({
  height = normalize(24),
  width = normalize(24),
  color = theme.colors["neutral.500"],
  ...props
}) => (
  <Svg
    width={height}
    height={width}
    {...props}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 24 24"
  >
    <Path
      d="M20.0915 7.84286C19.8181 7.7256 19.5147 7.68746 19.2188 7.73317C18.923 7.77889 18.6477 7.90645 18.4273 8.1L16.4933 9.81429V8.57143C16.4933 7.88944 16.2089 7.23539 15.7028 6.75315C15.1967 6.27092 14.5103 6 13.7946 6H5.69865C4.98292 6 4.29651 6.27092 3.79042 6.75315C3.28432 7.23539 3 7.88944 3 8.57143V15.4286C3 16.1106 3.28432 16.7646 3.79042 17.2468C4.29651 17.7291 4.98292 18 5.69865 18H13.7946C14.5103 18 15.1967 17.7291 15.7028 17.2468C16.2089 16.7646 16.4933 16.1106 16.4933 15.4286V14.1857L18.4363 15.9C18.7223 16.1467 19.0939 16.2841 19.4798 16.2857C19.6939 16.2852 19.9054 16.2414 20.1004 16.1571C20.3658 16.0549 20.5931 15.8796 20.7533 15.6536C20.9135 15.4276 20.9994 15.1613 21 14.8886V9.11143C20.9987 8.83773 20.9115 8.57067 20.7496 8.34459C20.5877 8.11852 20.3585 7.94378 20.0915 7.84286ZM14.6942 15.4286C14.6942 15.6559 14.5994 15.8739 14.4307 16.0347C14.262 16.1954 14.0332 16.2857 13.7946 16.2857H5.69865C5.46008 16.2857 5.23127 16.1954 5.06257 16.0347C4.89387 15.8739 4.7991 15.6559 4.7991 15.4286V8.57143C4.7991 8.3441 4.89387 8.12608 5.06257 7.96534C5.23127 7.80459 5.46008 7.71429 5.69865 7.71429H13.7946C14.0332 7.71429 14.262 7.80459 14.4307 7.96534C14.5994 8.12608 14.6942 8.3441 14.6942 8.57143V15.4286ZM19.1919 14.2286L16.6642 12L19.1919 9.77143V14.2286Z"
      fill={color}
    />
  </Svg>
);

export default CameraVideoIcon;
